class BusinessHours {
	constructor() {
		this.hoursElement = document.querySelector('.hours-of-operation');
		this.timesElement = this.hoursElement?.querySelector('.hours-of-operation__times');

		this.init();
	}

	init() {
		if (!this.hoursElement || !this.timesElement) return;

		const hoursText = this.timesElement.textContent.trim();
		const isOpen = this.isCurrentlyOpen(hoursText);

		const statusElement = document.createElement('sup');
		statusElement.classList.add('hours-status', isOpen ? 'open' : 'closed');
		statusElement.textContent = isOpen ? 'Open' : 'Closed';

		this.timesElement.appendChild(statusElement);
	}

	parseTime(timeStr) {
		const match = timeStr.match(/(\d+):(\d+)\s*(AM|PM)/i);
		if (!match) return null;

		let [, hours, minutes, period] = match;
		hours = parseInt(hours);
		minutes = parseInt(minutes);

		// Convert to 24-hour format
		if (period.toUpperCase() === 'AM') {
			if (hours === 12) hours = 0; // 12 AM = midnight
		} else {
			if (hours !== 12) hours += 12; // PM, but not 12 PM
		}

		return hours * 60 + minutes; // Return total minutes for easy comparison
	}

	isCurrentlyOpen(hoursText) {
		// Get current time in NY timezone
		const now = new Date();
		const nyTimeStr = now.toLocaleString('en-US', {
			timeZone: 'America/New_York',
			hour: 'numeric',
			minute: 'numeric',
			hour12: false,
		});

		const [currentHour, currentMinute] = nyTimeStr.split(':').map(Number);
		const currentMinutes = currentHour * 60 + currentMinute;

		// Parse "5:30 AM – 12:00 AM" format
		const times = hoursText.match(/\d+:\d+\s*[AP]M/gi);
		if (!times || times.length < 2) return false;

		const openMinutes = this.parseTime(times[0]);
		let closeMinutes = this.parseTime(times[1]);

		// Handle midnight (12:00 AM = end of day, so treat as 24:00)
		if (closeMinutes === 0) {
			closeMinutes = 24 * 60;
		}

		return currentMinutes >= openMinutes && currentMinutes < closeMinutes;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new BusinessHours();
});

export default BusinessHours;
